import TransactionUtil from '@/util/transactionutil'

export default {
  async check_input(state, commit, system, object, fn, field, input) {
    const obj_data = await TransactionUtil.getObjectMetadata(state, commit, system + '.' + object)
    if (!(field in obj_data.object_functions[fn].parameters)) {
      window.console.warn(`Type check failed: ${system}.${object}.${fn} parameter ${field} not found`)
      return false
    }
    return this.check_input_by_datatype(state, obj_data.object_functions[fn].parameters[field].data_type, input)
  },
  async check_input_by_datatype(state, dataTypeName, input) {
    try {
      const dataType = state.db_editor_data_type_cache[dataTypeName]
      if (Number.isInteger(dataType.text_length) && input.length > dataType.text_length) {
        window.console.debug('typechecker: reject because of length')
        return false
      }
      return true
    } catch (e) {
      window.console.warn('Type check failed:')
      window.console.warn(e)
      return false
    }
  }
}
